// ** React Imports
import { useLocation } from "react-router-dom"

// ** Third Party Components
import { useTranslation } from "react-i18next"

// ** Config
import { getPageTitle } from "@configs/pageTitles"

// ** Título y subtítulo de la pantalla actual, a la izquierda del header.
// Bloque nuevo del rediseño: el layout de la plantilla no lo tenía.
const PageTitle = () => {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  const page = getPageTitle(pathname)

  // Las rutas sin entrada en el mapa (login, error) no pintan cabecera.
  if (!page) return null

  return (
    <div className="bp-page-title">
      <div className="bp-page-title__title">{t(page.title)}</div>
      {page.subtitle ? (
        <div className="bp-page-title__subtitle">{t(page.subtitle)}</div>
      ) : null}
    </div>
  )
}

export default PageTitle
